export default {
    SAVE_COURIER_ADDRESS: 'SAVE_COURIER_ADDRESS',
    FETCH_STEPS: 'FETCH_STEPS',
    CHANG_ACTIVE_STEP: 'CHANG_ACTIVE_STEP',
    REGISTER_SAVE_DATA: 'REGISTER_SAVE_DATA',
    CHANGE_CURRENT_STEP: 'CHANGE_CURRENT_STEP',
    FINALIZE_STEP: 'FINALIZE_STEP',
    ENABLE_STEP: 'ENABLE_STEP',
    ENABLE_CURRENT_STEP: 'ENABLE_CURRENT_STEP',
    DISABLE_FOLLOWING_STEP: 'DISABLE_FOLLOWING_STEP',
    DISABLE_PREVIOUS_STEPS: 'DISABLE_PREVIOUS_STEPS',
    ENABLE_PREVIOUS_STEPS: 'ENABLE_PREVIOUS_STEPS',
    ENABLE_FINISHED_STEP: 'ENABLE_FINISHED_STEP',
    DEFAULT_STEPS: 'DEFAULT_STEPS',
    AUTHORIZED_STEPS: 'AUTHORIZED_STEPS',
    CLIENT_STEPS: 'CLIENT_STEPS',
    CONFIG_CARD_STEPS: 'CONFIG_CARD_STEPS',
    SET_MIN_FINALIZE_STEP: 'SET_MIN_FINALIZE_STEP',
    LOAD_ADDRESSES: 'LOAD_ADDRESSES',
    LOAD_ARES: 'LOAD_ARES',
    LOAD_ADDRESSES_ERROR: 'LOAD_ADDRESSES_ERROR',
    ADD_COUNTRIES: 'ADD_COUNTRIES',
    ADD_CITIES: 'ADD_CITIES',
    ADD_TYPES_OF_ROADS: 'ADD_TYPES_OF_ROADS',
    ADD_WORK_FOR: 'ADD_WORK_FOR',
    ADD_PROFESSIONS_WORK_FOR_EMPLOYED: 'ADD_PROFESSIONS_WORK_FOR_EMPLOYED',
    ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED: 'ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED',
    ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED_CODE: 'ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED_CODE',
    SHOW_FULL_HOME_ADDRESS: 'SHOW_FULL_HOME_ADDRESS',
    SHOW_FULL_POSTAL_ADDRESS: 'SHOW_FULL_POSTAL_ADDRESS',
    SET_FOCUS: 'SET_FOCUS',
    SET_STANDBY_JOINT_HOLDERS: 'SET_STANDBY_JOINT_HOLDERS',
    CONTRACT_URL: 'CONTRACT_URL',
    CONTRACT_STATUS: 'CONTRACT_STATUS',
    CONTRACT_LOADING: 'CONTRACT_LOADING',
    CONTRACT_LOADED: 'CONTRACT_LOADED',
    SHOW_MODAL_CANCEL: 'SHOW_MODAL_CANCEL',
    HIDE_MODAL_CANCEL: 'HIDE_MODAL_CANCEL',
    SHOW_MAP: 'SHOW_MAP',
    HIDE_MAP: 'HIDE_MAP',
    ADD_BRANCHES: 'ADD_BRANCHES',
    CLEAR_BRANCHES: 'CLEAR_BRANCHES',
    SHOW_SPINNER: 'SHOW_SPINNER',
    SHOW_SPINNER_2: 'SHOW_SPINNER_2',
    HIDE_SPINNER: 'HIDE_SPINNER',
    HIDE_SPINNER_2: 'HIDE_SPINNER_2',
    PRELOADER_INFORMATION_TEXT: 'PRELOADER_INFORMATION_TEXT',
    PRELOADER_INFORMATION_ARRAY: 'PRELOADER_INFORMATION_ARRAY',
    LOAD_CONTRACTUAL_INFO: 'LOAD_CONTRACTUAL_INFO',
    CLEAR_CONTRACTUAL_INFO: 'CLEAR_CONTRACTUAL_INFO',
    CHANGE_TIME_LEFT: 'CHANGE_TIME_LEFT',
    RENEW_STATUS: 'RENEW_STATUS',
    VIDEO_CALL_URL: 'VIDEO_CALL_URL',
    VIDEO_CALL_STATUS: 'VIDEO_CALL_STATUS',
    VIDEO_CALL_RESET: 'VIDEO_CALL_RESET',
    VIDEO_AVAILABILITY: 'VIDEO_AVAILABILITY',
    TRIGGER_VALIDATION: 'TRIGGER_VALIDATION',
    GET_DOCUMENT_INFO: 'GET_DOCUMENT_INFO',
    CLEAR_DOCUMENT_INFO: 'CLEAR_DOCUMENT_INFO',
    GET_PROMO_CODE_RESULT: 'GET_PROMO_CODE_RESULT',
    CLEAR_PROMO_CODE_RESULT: 'CLEAR_PROMO_CODE_RESULT',
    BATCH_ERROR: 'BATCH_ERROR',
    GET_PDF_MERGED: 'GET_PDF_MERGED',
    CLEAR_PDF_MERGED: 'CLEAR_PDF_MERGED',
    IS_LOADED_IN_DOCUMENTATION: 'IS_LOADED_IN_DOCUMENTATION',
    SERVER_DATE: 'SERVER_DATE',
    INITIAL_STEP_COMPLETED: 'INITIAL_STEP_COMPLETED',
    ERROR_IN_RESPONSE: 'ERROR_IN_RESPONSE',
    CLOSED_BY_NEW_LOGIN: 'CLOSED_BY_NEW_LOGIN',
    SHOW_HEADER: 'SHOW_HEADER',
    HIDE_HEADER: 'HIDE_HEADER',
    ADD_IBANBANKENTITIES: 'ADD_IBANBANKENTITIES',
    SHOW_WELCOME_CARD: 'SHOW_WELCOME_CARD',
    HIDE_WELCOME_CARD: 'HIDE_WELCOME_CARD',
    CLEAR_PROFESSION_LIST: 'CLEAR_PROFESSION_LIST',
    GET_PROFESSION_CATEGORIES_CNO: 'GET_PROFESSION_CATEGORIES_CNO',
    GET_PROFESSION_CATEGORIES_CNAE: 'GET_PROFESSION_CATEGORIES_CNAE',
    ADD_PROFESSIONS_WORK_FOR_EMPLOYED_SUBCATEGORIES: 'ADD_PROFESSIONS_WORK_FOR_EMPLOYED_SUBCATEGORIES',
    ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED__SUBCATEGORIES: 'ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED__SUBCATEGORIES',
    CLEAR_SUBCATEGORIES_PROFESSION_LIST: 'CLEAR_SUBCATEGORIES_PROFESSION_LIST',
    CLEAR_CATEGORIES_LIST: 'CLEAR_CATEGORIES_LIST',
    SET_PROMO_CODE_EXPIRED: 'SET_PROMO_CODE_EXPIRED',
    GET_PROFESSION_SECTOR_CATEGORIES: 'GET_PROFESSION_SECTOR_CATEGORIES',
    GET_PROFESSION_SECTOR: 'GET_PROFESSION_SECTOR',
    CLEAR_PROFESSION_SECTOR: 'CLEAR_PROFESSION_SECTOR',
    FETCH_JOINT_HOLDERS_REQUEST: 'FETCH_JOINT_HOLDERS_REQUEST',
    FETCH_JOINT_HOLDERS_SUCCESS: 'FETCH_JOINT_HOLDERS_SUCCESS',
    FETCH_JOINT_HOLDERS_FAILURE: 'FETCH_JOINT_HOLDERS_FAILURE',
    FETCH_DATA_HOLDER_SUCCESS: 'FETCH_DATA_HOLDER_SUCCESS',
    FETCH_DATA_HOLDER_FAILURE: 'FETCH_DATA_HOLDER_FAILURE',
    FINALIZE_STEPS: 'FINALIZE_STEPS',
    GET_CARD_IMAGES: 'GET_CARD_IMAGES',
    LOAD_PRODUCTS: 'LOAD_PRODUCTS',
    LOAD_PARTNER: 'LOAD_PARTNER',
    UPDATE_PRODUCTS: 'UPDATE_PRODUCTS',
    CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',
    SET_WEALTH_PRODUCT: 'SET_WEALTH_PRODUCT',
    ERROR_WEALTH_PRODUCT: 'ERROR_WEALTH_PRODUCT',
    GET_CREDIT_CARD_IMAGE: 'GET_CREDIT_CARD_IMAGE',
    OKIBAN_SET_IBAN: 'OKIBAN_SET_IBAN',
    OKIBAN_ERROR: 'OKIBAN_ERROR',
    OKIBAN_RESET: 'OKIBAN_RESET',
    OKIBAN_INTERNAL_RESET: 'OKIBAN_INTERNAL_RESET',
    LOAD_CMS_REGISTER: 'LOAD_CMS_REGISTER',
    LOAD_CMS_ADDITIONAL: 'LOAD_CMS_ADDITIONAL',
    LOAD_CMS_POSTFIOC_APPROVED: 'LOAD_CMS_POSTFIOC_APPROVED',
    LOAD_CMS_POSTFIOC_NOT_APPROVED: 'LOAD_CMS_POSTFIOC_NOT_APPROVED',
    LOAD_CMS_STAND_BY: 'LOAD_CMS_STAND_BY',
    LOAD_JAFFAR: 'LOAD_JAFFAR',
    LOAD_ML2: 'LOAD_ML2',
    LOAD_LOGO: 'LOAD_LOGO',
    ROBO_STEPS: 'ROBO_STEPS',
    DEPOSIT_STEPS: 'DEPOSIT_STEPS',
    GBI_STEPS: 'GBI_STEPS',
    HIRE_CARD_IMAGE_SELECTOR_FAILURE: 'HIRE_CARD_IMAGE_SELECTOR_FAILURE',
    HIRE_CARD_IMAGE_SELECTOR_REQUEST: 'HIRE_CARD_IMAGE_SELECTOR_REQUEST',
    HIRE_CARD_IMAGE_SELECTOR_RESET: 'HIRE_CARD_IMAGE_SELECTOR_RESET',
    HIRE_CARD_IMAGE_SELECTOR_SUCCESS: 'HIRE_CARD_IMAGE_SELECTOR_SUCCESS',
    HIRE_CARD_IMAGE_UPDATE_SELECTED_ID: 'HIRE_CARD_IMAGE_UPDATE_SELECTED_ID',
    SHOW_HIRE_SOLIDATY_CARD_VIEW: 'SHOW_HIRE_SOLIDATY_CARD_VIEW',
    HIDE_HIRE_SOLIDATY_CARD_VIEW: 'HIDE_HIRE_SOLIDATY_CARD_VIEW',
    RA_ROBO_LOGIN_SUCCESS: 'RA_ROBO_LOGIN_SUCCESS',
    RA_ROBO_LOGIN_FALIURE: 'RA_ROBO_LOGIN_FALIURE',
    RA_ROBO_LOGIN_RESET_ERRORS: 'RA_ROBO_LOGIN_RESET_ERRORS',
    TRANSLATIONS_FETCH_REQUEST: 'TRANSLATIONS_FETCH_REQUEST',
    TRANSLATIONS_REQUEST_SUCCESS: 'TRANSLATIONS_REQUEST_SUCCESS',
    TRANSLATIONS_REQUEST_FAILURE: 'TRANSLATIONS_REQUEST_FAILURE',
    FROM_INITIAL_STEP: 'FROM_INITIAL_STEP',
    GET_DEBIT_CARDS: 'GET_DEBIT_CARDS',
    UPDATE_CARD_INFO: 'UPDATE_CARD_INFO',
    VALIDATION_DATA_ALREADY_CLIENT_REQUEST: 'VALIDATION_DATA_ALREADY_CLIENT_REQUEST',
    VALIDATION_DATA_ALREADY_CLIENT_FAILURE: 'VALIDATION_DATA_ALREADY_CLIENT_FAILURE',
    VALIDATION_DATA_ALREADY_CLIENT_SUCCESS: 'VALIDATION_DATA_ALREADY_CLIENT_SUCCESS',
    VALIDATION_DATA_ALREADY_CLIENT_RESET: 'VALIDATION_DATA_ALREADY_CLIENT_RESET',
    FEATURE_FLAGGING_FETCH_REQUEST: 'FEATURE_FLAGGING_FETCH_REQUEST',
    FEATURE_FLAGGING_REQUEST_SUCCESS: 'FEATURE_FLAGGING_REQUEST_SUCCESS',
    FEATURE_FLAGGING_REQUEST_FAILURE: 'FEATURE_FLAGGING_REQUEST_FAILURE',
    SET_PROMO_CODE_ERROR_ROBO: 'SET_PROMO_CODE_ERROR_ROBO',
    RESET_PROMO_CODE_ERROR_ROBO: 'RESET_PROMO_CODE_ERROR_ROBO',
    IDENTIFY_IBAN: 'IDENTIFY_IBAN',
    IDENTIFY_VIDEO_CALL: 'IDENTIFY_VIDEO_CALL',
    IDENTIFY_TRANSFER: 'IDENTIFY_TRANSFER',
    POLL_START: 'POLL_START',
    POLL_STOP: 'POLL_STOP',
    UPDATE_POLLING_STATS: 'UPDATE_POLLING_STATS',
    VIDEO_STATUS: 'VIDEO_STATUS',
    VIDEO_URL: 'VIDEO_URL',
    VIDEO_RESET: 'VIDEO_RESET',
    CREDIT_CARD_STEPS: 'CREDIT_CARD_STEPS',
    GET_INE_PDF: 'GET_INE_PDF',
    SHOW_GLOBAL_ERROR_MODAL: 'SHOW_GLOBAL_ERROR_MODAL',
    SET_CALLBACK_GLOBAL_ERROR_MODAL: 'SET_CALLBACK_GLOBAL_ERROR_MODAL',
    SET_INFO_GLOBAL_ERROR_MODAL: 'SET_INFO_GLOBAL_ERROR_MODAL',
    SET_ONBOARDING_IMPLEMENTATION: 'SET_ONBOARDING_IMPLEMENTATION',
};
